// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck - may need to be at the start of file
import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { Alert, NativeSyntheticEvent, TextInput, TextInputKeyPressEventData } from 'react-native';
import { useForm, Controller, SubmitErrorHandler, FieldValues, SubmitHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Logger } from '@fkhplus/common/src/utils/logger';
import { PlatformUtils } from '@fkhplus/common/src/utils/PlatformUtils';
import { otpRegex } from '@fkhplus/common/src/constants/RegexPatterns';
import Button from "@fkhplus/common/src/components/atoms/Button";
import Icon, { IconsName } from '@fkhplus/common/src/components/atoms/icon/icon';
import OtpInputBox from '@fkhplus/common/src/components/atoms/OTPInput';
import Timer from '@fkhplus/common/src/components/atoms/Timer';
import { AuthenticationText, Container, Content, OTPInputContainer, OTPLabel, TimerContainer } from '@fkhplus/common/src/components/molecules/OTPVerification/Style';

interface IOTPVerificationProps {
  onSubmitOTP:()=>void;
  otp: string;
  resetListner:()=> void
}


const OTPVerification: FC<IOTPVerificationProps> = (props:IOTPVerificationProps): React.ReactElement => {
  const initialState = ['', '', '', '', '', ''];
  const [otpArray, setOtpArray] = useState(initialState);
  const [showResend, setShowResend] = useState(false);
  const { t } = useTranslation();
  const [retryCount, setRetryCount] = useState(0);
  const [timer,setTimer] = useState(30);
  const { register, setValue, handleSubmit, control, reset, formState: { errors, touchedFields },clearErrors } = useForm();
  const firstTextInputRef = useRef<any>();
  const secondTextInputRef = useRef<any>();
  const thirdTextInputRef = useRef<any>();
  const fourthTextInputRef = useRef<any>();
  const fifthTextInputRef = useRef<any>();
  const sixthTextInputRef = useRef<any>();
  const ref = useRef(null);

  const onSubmit: SubmitHandler<FieldValues> = (data) => {
    props.onSubmitOTP()
  };

  const onError: SubmitErrorHandler<FieldValues> = (errors) => {
    setRetryCount((value)=>{
      const count: number = value+1;
      if(count>=3){
        //TODO Harshith | 2-02-2022  |Add capha logic here
        Alert.alert("show captcha")
      }
      return count
    })
    Logger.info(JSON.stringify(errors))
  }


  const refCallback = (textInputRef: React.RefObject<TextInput>) => (node: React.RefObject<TextInput>) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    textInputRef.current = node;
  };

  const checkOTPCallback = useCallback(():boolean => {
    for (let index = 0; index < otpArray.length; index++) {
      if (otpArray[index] == '') {
        return false
      }
    }
    return true;
  },[otpArray])

  useEffect(()=>{
    const otpProp: string = props.otp
    if(otpProp?.length > 4){
      const options = { shouldValidate: true ,shouldDirty:true,shouldTouch:true};
      setValue('0', otpProp[0],options);
      setValue('1', otpProp[1],options);
      setValue('2', otpProp[2]),options;
      setValue('3', otpProp[3],options);
      setValue('4', otpProp[4],options);
      setValue('5', otpProp[5],options);
      setOtpArray(['1','1','1','1','1','1'])
    }
  },[props.otp])


  useEffect(() => {
    if (checkOTPCallback()) {
      handleSubmit(onSubmit, onError)()
    }
    
  }, [otpArray])

  const onOtpChange = useCallback((index: number, onChange: (value: string) => void) => {
    return (value: string) => {
      if (isNaN(Number(value))) {
        return;
      }
      onChange && onChange(value);

      const otpArrayCopy = [...otpArray]
      otpArrayCopy[index] = value;
      setOtpArray(otpArrayCopy);

      if (value !== '' && secondTextInputRef?.current != undefined) {
        if (index === 0) {
          secondTextInputRef.current.focus();
        } else if (index === 1) {
          thirdTextInputRef.current.focus();
        } else if (index === 2) {
          fourthTextInputRef.current.focus();
        }
        else if (index === 3) {
          fifthTextInputRef.current.focus();
        }
        else if (index === 4) {
          sixthTextInputRef.current.focus();
        }
      }
    };
  },[otpArray]);

  const onOtpKeyPress = useCallback((index: number) => {
    return ({ nativeEvent: { key: value } }: NativeSyntheticEvent<TextInputKeyPressEventData>) => {

      if (value === 'Backspace' && otpArray[index] === '') {
        if (index === 1) {
          firstTextInputRef.current.focus();
        } else if (index === 2) {
          secondTextInputRef.current.focus();
        } else if (index === 3) {
          thirdTextInputRef.current.focus();
        }
        else if (index === 4) {
          fourthTextInputRef.current.focus();
        } else if (index === 5) {
          fifthTextInputRef.current.focus();
        }
 
        if (index > 0) {
          const otpArrayCopy = [...otpArray];

          otpArrayCopy[index - 1] = '';
          setOtpArray(otpArrayCopy);
        }

      }      
    };
  },[otpArray]);

const isError: boolean = Object.keys(errors).length > 0;


const resendOTP=()=>{
  const {resetListner} = props;
  setShowResend(false);
  reset();
  clearErrors();
  setOtpArray(initialState);
  setTimer(30);
  firstTextInputRef.current.focus();
  !!resetListner && resetListner()
  ref?.current?.resetTimer()
}


const renderTimer = (): React.ReactElement=>{

     if(!showResend){
      return <Timer
      timeLimit={timer}
      onTimerEnd={()=>setShowResend(true)}
      style={{left:12}}
      key={1}
      ref={ref}
      /> 
    }
    else{
      return <Button
      title={t('auth:enterOTPManually')}
      onPress={()=>firstTextInputRef.current.focus()}
      textStyle={{fontWeight:'bold'}}
      containerStyles={{backgroundColor:'transparent'}}
    />
    }
}
  return (
    <Container>

      <OTPLabel hasError={isError}>
       {t('auth:enterOTP')}
      </OTPLabel>
<>
      <OTPInputContainer>
        {[
          firstTextInputRef,
          secondTextInputRef,
          thirdTextInputRef,
          fourthTextInputRef,
          fifthTextInputRef,
          sixthTextInputRef
        ].map((textInputRef, index) => (
          <Controller
            control={control}
            render={({
              field: { onChange, onBlur, value },
              fieldState: { invalid, isTouched, isDirty, error },
              formState,
            }): React.ReactElement => {
              return (
                <OtpInputBox
                  containerStyle={{ width: 40, height: 40 }}
                  onKeyPress={onOtpKeyPress(index)}
                  onChangeText={onOtpChange(index, onChange)}
                  keyboardType={'numeric'}
                  maxLength={1}
                  onBlur={onBlur}
                  hasError={isError}
                  value={value}
                  textContentType={'oneTimeCode'}
                  inputStyle={{ padding: 6, paddingHorizontal: 10 }}
                  autoFocus={index==0?true:false}
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  //@ts-ignore
                  refCallback={refCallback(textInputRef)}
                  key={index}
                />
              )
            }}
            name={String(index)}
            rules={{
              required: true,
              maxLength: 1,
              pattern: { value: otpRegex, message: '' },
            }}
            //TODO pattern after demo /^(0|[1-9][0-9]*)$/
            key={index}
          />
        ))}
      </OTPInputContainer>
      
      {isError && <TimerContainer>
      <Icon name={IconsName.error} size={PlatformUtils.isAndroid()?15:15} color={'red'} />
        <AuthenticationText>
        {t('auth:authCodeError')}
        </AuthenticationText>
        </TimerContainer>}
        </>
      <Content>
      {renderTimer()}
        

        {(showResend || isError) && (<Button
          title={t('auth:resendOTP')}
          onPress={()=>resendOTP()}
          textStyle={{fontWeight:'bold'}}
          containerStyles={{backgroundColor:'transparent'}}
        />)}
      </Content>

    </Container>
  )
}



export default OTPVerification;



